export const EDT = 'America/New_York';
export const UTC = 'Europe/London';
export const CDT = 'America/North_Dakota/New_Salem';

export const MIN_FILTER_LENGTH = 3;

export const images = {
  lingerieParty: '/ItineraryIdeas/lingerieParty.jpg',
  mimosaBreakfast: '/ItineraryIdeas/mimosaBreakfast.jpg',
  bacheloretteGames: '/ItineraryIdeas/bacheloretteGames.jpg',
  theSundayAfterBrunch: '/ItineraryIdeas/theSundayAfterBrunch.jpg',
  afternoonHike: '/ItineraryIdeas/Afternoon-Hike.jpg',
  barCrawl: '/ItineraryIdeas/Bar-Crawl.jpg',
  gamblingTime: '/ItineraryIdeas/Gambling-Time.jpg',
  beerGarden: '/ItineraryIdeas/Beer-Garden.png',
};

export const MOBILE_RESOLUTION = '768px';
